import { render } from "./InputValor.vue?vue&type=template&id=167bab4f&scoped=true"
import script from "./InputValor.vue?vue&type=script&lang=js"
export * from "./InputValor.vue?vue&type=script&lang=js"

import "./InputValor.vue?vue&type=style&index=0&id=167bab4f&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-167bab4f"],['__file',"src/components/Input/InputValor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "167bab4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('167bab4f', __exports__)) {
    console.log('reload')
    api.reload('167bab4f', __exports__)
  }
  
  module.hot.accept("./InputValor.vue?vue&type=template&id=167bab4f&scoped=true", () => {
    console.log('re-render')
    api.rerender('167bab4f', render)
  })

}


export default __exports__